module.exports = __webpack_public_path__ + "static/media/about-expert.7a10909f.png";